module.exports = __webpack_public_path__ + "assets/img/r4.6a35666a.png";